// Jumping to one setting on the Settings page: the page scrolls inside its own scroller, not the window

export const LOCATED_CLASS = 'is-located'

// The element with this id inside root, or null
export const elementById = (root, id) => (root ? root.querySelector('[id="' + id + '"]') : null)

// Where the pinned section list starts in the scroller. A sticky top counts from inside the scroller's padding, so
// the padding adds to it.
export const pinnedTop = (scroller) => {
  const aside = scroller?.querySelector('.settings-layout__aside')
  if (!aside) {
    return 0
  }

  return (parseFloat(window.getComputedStyle(aside).top) || 0) + (parseFloat(window.getComputedStyle(scroller).paddingTop) || 0)
}

// Scrolls the setting to just under the pinned list's top and makes it glow once; false when it isn't on the page
export const revealSettingElement = (scroller, field) => {
  if (!scroller || !field) {
    return false
  }

  scroller.scrollTop += field.getBoundingClientRect().top - scroller.getBoundingClientRect().top - pinnedTop(scroller)
  field.classList.remove(LOCATED_CLASS)
  // Reading a size restarts the glow when the same setting is found twice
  field.getBoundingClientRect()
  field.classList.add(LOCATED_CLASS)
  // A hidden section's glow would replay when it opens again, so the class goes once the glow ends
  const done = (event) => {
    if (event.target !== field) {
      return
    }
    field.classList.remove(LOCATED_CLASS)
    field.removeEventListener('animationend', done)
    field.removeEventListener('animationcancel', done)
  }
  field.addEventListener('animationend', done)
  field.addEventListener('animationcancel', done)

  return true
}

// A section's form can render a moment after the route opens it, so the jump waits for its setting a few frames
export const revealSettingWhenShown = (scroller, id, frames = 30) => new Promise((resolve) => {
  const attempt = (left) => {
    const field = elementById(scroller, id)
    if (field || left === 0) {
      resolve(revealSettingElement(scroller, field))
      return
    }
    window.requestAnimationFrame(() => attempt(left - 1))
  }
  attempt(frames)
})
